<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les Responsables Institutionnels" />
            <LesResponsables />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesResponsables from './LesResponsables.vue'


export default {
    name: 'LesResponsablesPage',
    components: {
        NavBar,
        PageTitle,
        LesResponsables,
        FooterComp,
    }
}
</script>